import React, { useState, useEffect, Fragment, useRef } from 'react';
import $ from 'jquery';
import services from '../services';
import { validateProperty, validate } from "../../Common";
import { PageHeader } from '../../../Common';
import Joi from '@hapi/joi';
import TextField from '@material-ui/core/TextField';
import authService from '../../Common/services';
import { InputLabel, Select } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import groupService from '../../Group/services';
import { goodsReceivedNoteSchemaObject } from '../GoodsReceivedNoteSchema';
import { trackPromise } from 'react-promise-tracker';
import FormHelperText from '@material-ui/core/FormHelperText';
import { TableContentWithoutEdit } from '../../Common/Table/tableContent';
import collectionPointService from '../../GoodsReceiveNote/services';
import { CSVLink, CSVDownload } from "react-csv";
import CreatePDF from './createPDF';
import ReactToPrint from "react-to-print";
import tokenService from '../../../Common/tokenDecoder';
import '../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import _ from 'lodash';

const screenCode = 'GOODSRECEIVENOTEREPORT';

export function GoodsReceiveNoteReport(props) {

    const contentRowNames = ["fieldName", "totalAmount", "deduction", "netAmount", "bagCount"];
    const [isTableHide, setIsTableHide] = useState(true);
    const [groups, setGroups] = useState([]);
    const [group, setGroup] = useState([]);
    const [estates, setEstates] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [grns, setGrn] = useState([]);
    const [reportData, setReportData] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [keys, setKeys] = useState([]);
    const schema = Joi.object(goodsReceivedNoteSchemaObject).options({ allowUnknown: true });
    const [errors, setErrors] = useState([]);
    const [grnNumbers, setGrnNumbers] = useState([]);
    const [transferNote, setTransferNote] = useState([]);
    const [isReportButtonsEnabled, setIsReportButtonsEnabled] = useState(false);
    const [csvData, setCsvData] = useState([]);
    const [filterGRNS, setFilterGRNS] = useState([]);
    const pdfRef = React.createRef();
    const componentRef = useRef();

    const csvHeaders = [
        { label: "Field", value: "fieldName" },
        { label: "Gross Amount (Kg)", value: "totalAmount" },
        { label: "Deduction (Kg)", value: "deduction" },
        { label: "Net Amount (Kg)", value: "netAmount" },
        { label: "Bag", value: "bagCount" },
    ];

    const [collectionCategory, setCollectionCatogory] = useState({
        groupID: "0",
        estateID: "0",
        divisionID: "0",
        dateID: '',
        grnNumber: "0"

    });

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        estate: "",
        division: "",
        date: "",
    });

    let searchForm = {

        groupID: parseInt(collectionCategory.groupID),
        estateID: parseInt(collectionCategory.estateID),
        dateID: collectionCategory.dateID,
    }
    let goodstest = {
        grnNumber: (collectionCategory.grnNumber == '0' || collectionCategory.grnNumber == undefined || collectionCategory.grnNumber == null) ? null : collectionCategory.grnNumber,
        groupID: parseInt(collectionCategory.groupID),
        estateID: parseInt(collectionCategory.estateID),
        divisionID: collectionCategory.divisionID == '0' ? null : collectionCategory.divisionID,
        dateID: collectionCategory.dateID,
        grnID: ''

    }

    useEffect(() => {
        trackPromise(
            getPermissions(),
        )
    }, []);

    useEffect(() => {
        trackPromise(
            getEstateForDropDown()
        )
    }, [collectionCategory.groupID]);

    useEffect(() => {
        trackPromise(
            getDivisionForDropDown()
        )
    }, [collectionCategory.estateID]);

    useEffect(() => {
        trackPromise(
            getGrnForDropDown()
        )
    }, [collectionCategory.dateID], [collectionCategory.estateID]);

    useEffect(() => {
        setNewGrns()
    }, [collectionCategory.divisionID]);

    async function handleChange(e) {

        const target = e.target;
        const value = target.value;

        const error = { ...errors }

        const errorMessage = validateProperty(target, goodsReceivedNoteSchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]


        setCollectionCatogory(
            {
                ...collectionCategory,
                [e.target.name]: value
            }
        );

        setErrors(error);
    }

    function handleChangeEstate(e) {

        const target = e.target;
        const value = target.value;
        const error = { ...errors }
        const errorMessage = validateProperty(target, goodsReceivedNoteSchemaObject)

        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setCollectionCatogory({
            ...collectionCategory,
            [e.target.name]: value
        });
        setErrors(error);
    }

    function handleChangeDivision(e) {
        const target = e.target;
        const value = target.value;

        setCollectionCatogory({
            ...collectionCategory,
            [e.target.name]: value
        });

    }

    function handleChangeDate(e) {
        const target = e.target;
        const value = target.value;
        const error = { ...errors }
        const errorMessage = validateProperty(target, goodsReceivedNoteSchemaObject)

        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setCollectionCatogory({
            ...collectionCategory,
            [e.target.name]: value
        });
        setErrors(error);
    }

    function handleChangeGRN(e) {
        const target = e.target;
        const value = target.value;

        setCollectionCatogory({
            ...collectionCategory,
            [e.target.name]: value
        });
    }
    function setNewGrns() {
        var fgrns = [];
        if (collectionCategory.divisionID != '0') {
            fgrns = grns.filter(grn => grn.collectionPointID == collectionCategory.divisionID);
            setFilterGRNS(fgrns);
        } else {
            setFilterGRNS(grns);
        }
    }

    function generateDropDownMenu(data) {

        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function generateDropDownMenuEstate(data) {

        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<option key={key} value={key}>{value}</option>);
            }
        }
        return items;
    }

    function generateDropDownMenuDivision(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<option key={key} value={key}>{value}</option>);
            }
        }
        return items;
    }

    function generateDropDownMenuGRN(data) {

        let items = [];
        if (data != null || data != undefined) {
            data.map((item) => {
                items.push(
                    <MenuItem key={item.grnNumber} value={item.grnNumber}>
                        {item.grnNumber}
                    </MenuItem >
                );
            });
        }
        return items;
    }

    function setSelectedSearchData() {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[goodstest.groupID],
            estate: estates[goodstest.estateID],
            division: divisions[goodstest.divisionID],
            date: goodstest.dateID
        })
    }

    function onCancelClick() {
        clearState();
    }

    function clearState() {

        setCollectionCatogory({
            groupID: '0',
            estateID: '0',
            divisionID: '0',
            dateID: '',
            grnNumber: '0'
        });
        setIsTableHide(true);
        setErrors("");
        setIsReportButtonsEnabled(false);
    }

    function destroyDataTable() {
        grnNumbers.forEach(x => {
            $(`#${x}`).DataTable().destroy();
        })
    }

    function createDataTable() {
        grnNumbers.forEach(x => {
            $(`#${x}`).DataTable();
        })
    }

    function groupByGrn(objectArray) {
        return objectArray.reduce(function (acc, obj) {
            let key = obj['grnNumber']
            if (!acc[key]) {
                acc[key] = []
            }
            acc[key].push(obj)
            return acc
        }, {})
    }

    async function getGroupsForDropdown() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups);
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWGOODSRECEIVENOTEREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();

        setCollectionCatogory({
            ...collectionCategory,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });

        getGroupsForDropdown()

    }

    async function handleSearch(e) {
        e.preventDefault();

        const errorMessages = validate(schema, searchForm)
        errorMessages !== null ? setErrors(errorMessages) : setErrors({})
        if (errorMessages) return;

        setSelectedSearchData();

        setIsTableHide(true);

        const response = await collectionPointService.GetAllDetaisToTable(goodstest);
        setTransferNote(response.data);

        let groupedResult = groupByGrn(response.data);
        let keys = Object.keys(groupedResult);

        setGrnNumbers(keys);
        setReportData(groupedResult);

        if (keys.length > 0) {
            setIsReportButtonsEnabled(true);
        } else {
            setIsReportButtonsEnabled(false);
        }

        setIsTableHide(false);
        const result = response.data;

        const comlpeteData = [...result];
        setCsvData(comlpeteData);
    }

    function createFile() {
        var settings = {
            sheetName: 'Goods Receive Note',
            fileName: 'EstateComparisonReport',
            writeOptions: {}
        }
        var copyOfCsv = _.cloneDeep(csvData)

        var newRow1 = {
            fieldName: "Group :" + groups[collectionCategory.groupID],
            totalAmount: "Estate : " + estates[collectionCategory.estateID]

        }
        var newRow2 = {
            fieldName: "Date : " + collectionCategory.dateID,
            totalAmount: "GRN Number : " + collectionCategory.grnNumber
        }
        copyOfCsv.push({}, {}, newRow1)
        copyOfCsv.push(newRow2)

        xlsx(csvHeaders, copyOfCsv, settings, true)
    }

    async function getEstateForDropDown() {
        const estates = await services.GetAllFactoriesByGroupID(collectionCategory.groupID);
        setEstates(estates);
    }

    async function getDivisionForDropDown() {
        const divisions = await collectionPointService.GetAllWeighPointByOperationEntityID(collectionCategory.estateID);
        setDivisions(divisions);
    }

    async function getGrnForDropDown() {
        const grns = await collectionPointService.GetGRNNumberByDateAndFactory(collectionCategory.dateID, collectionCategory.estateID);
        setGrn(grns);
        setFilterGRNS(grns);
    }

    return (
        <Fragment>
            <div className="row">
                <div className="col-md-12 card">
                    <div className="card">

                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title="Goods Receive Note"
                                    isButtonEnable={false}
                                    buttonText="Back to Listing"
                                    path="/GoodsReceiveNote"
                                />
                            </div>
                            <hr />
                            <form onSubmit={(e) => handleSearch(e)} disabled={false}>
                                <div className="form-group row">
                                    <div className="col-md pb-1">

                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <TextField select
                                            fullWidth
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={collectionCategory.groupID}
                                            onChange={(e) => handleChange(e)}>
                                            <option value="0">--Select Group-- </option>
                                            {generateDropDownMenu(groups)}
                                        </TextField>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}


                                    </div>
                                    <div className="col-md-4">
                                        <InputLabel shrink id="estateID">Factory *</InputLabel>
                                        <TextField select
                                            fullWidth
                                            name="estateID"
                                            id="estateID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            value={collectionCategory.estateID}
                                            onChange={(e) => handleChangeEstate(e)}>
                                            <option value="0">--Select Factory-- </option>
                                            {generateDropDownMenuEstate(estates)}
                                        </TextField>
                                        {errors["estateID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>}

                                    </div>
                                    <div className="col-md-4">
                                        <InputLabel shrink id="dateID">Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            name="dateID"
                                            id="dateID"
                                            type="date"
                                            value={collectionCategory.dateID}
                                            onChange={(e) => handleChangeDate(e)}>
                                            <option value="0">--Select Date-- </option>
                                        </TextField>
                                        {errors["dateID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["dateID"]}</FormHelperText>
                                        }
                                    </div>

                                </div>

                                <br />

                                <div className="form-group row">

                                    <div className="col-md-4">
                                        <InputLabel shrink id="divisionID">Weigh Points</InputLabel>
                                        <TextField select
                                            fullWidth
                                            name="divisionID"
                                            id="divisionID"
                                            value={collectionCategory.divisionID}
                                            onChange={(e) => handleChangeDivision(e)}>
                                            <option value="0">--Select Weigh Point-- </option>
                                            {generateDropDownMenuDivision(divisions)}
                                        </TextField>

                                    </div>
                                    <div className="col-md-4">
                                        <InputLabel shrink id="grnID">GRN Number</InputLabel>
                                        <TextField select
                                            fullWidth
                                            name="grnNumber"
                                            id="grnNumber"
                                            value={collectionCategory.grnNumber}
                                            onChange={(e) => handleChangeGRN(e)}>
                                            <MenuItem value="0">--Select GRN Number-- </MenuItem>
                                            {generateDropDownMenuGRN(filterGRNS)}
                                        </TextField>

                                    </div>


                                </div>

                                <div className="card-footer">

                                    <input

                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={(e) => handleSearch(e)}
                                    />
                                    <input type="reset" className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>

                            </form>

                            {isTableHide ? null :

                                grnNumbers.map((x, index) => {

                                    return (

                                        <div key={index} className="card shadow-none ">
                                            <div className="row alternative_cls bg-light  ">
                                                <div className="card-body width1 "><p><b><p />GRN Number </b><br /><br /> {x}</p> </div>
                                                <div className="card-body width2"><p><b><p />WeighPoint Name </b><br /><br /> {reportData[x][0].collectionPointName}</p> </div>
                                                <div className="card-body width3"><p><b><p />Received Estate </b><br /><br />{reportData[x][0].transferedEstate}</p> </div>
                                                <div className="card-body width3"><p><b><p />Received Division </b><br /><br /> {reportData[x][0].transferedDivision}</p> </div>
                                                <div className="card-body width3"><p><b><p />Transfer Note</b><br /><br /> {reportData[x][0].transferNote}</p></div>
                                                <div className="card-body width4">

                                                    <table
                                                        id={x}
                                                        className="display dataTable no-footer">

                                                        <thead>
                                                            <tr>
                                                                <th>Field<br /></th>
                                                                <th>Gross Amount<br />(Kg)</th>
                                                                <th>Deduction<br />(Kg)</th>
                                                                <th>Net Amount<br />(Kg)</th>
                                                                <th>Bag <br />Count</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <TableContentWithoutEdit
                                                                data={reportData[x]}
                                                                contentRowNames={contentRowNames}
                                                                hasEdit={false}
                                                            />
                                                        </tbody>
                                                    </table>

                                                </div>

                                            </div>
                                            <hr />

                                        </div>
                                    )
                                })

                            }

                        </div>
                    </div>

                    {!isReportButtonsEnabled ? null :
                        <div className="pt-2">
                            <ReactToPrint
                                documentTitle={"Goods Receive Note"}
                                trigger={() => <input
                                    type="submit"
                                    className="btn btn-primary pull-right ml-2"
                                    value="Create PDF"
                                />}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePDF ref={componentRef} data={reportData}
                                    grnNUmbers={grnNumbers} rowNames={contentRowNames} searchData={selectedSearchValues} />
                            </div>
                            <input
                                type="button"
                                className="btn btn-primary pull-right ml-2"
                                value="Excel"
                                onClick={createFile}
                            />
                        </div>
                    }

                </div>
            </div>

        </Fragment>
    );
}